import { Injectable } from '@angular/core';
import { Action, Store, createAction } from '@ngrx/store';

// This is a "class interface" (aka "filthy hack") used for DI
export abstract class ActionDispatcher {
  dispatch(action: Action): void {};
}

@Injectable({
  providedIn: 'root'
})
export class DispatcherService extends ActionDispatcher {

  constructor(private readonly store: Store<any>) {
    super();
  }

  dispatch(action: Action): void {
    this.store.dispatch(action);
  }

}
